const request = {
    invalid_input: '輸入無效。{{details}}',
    general: '發生請求錯誤。',
    range_not_satisfiable: '範圍不滿足。',
};
export default Object.freeze(request);
